// extracted by mini-css-extract-plugin
export default {"bigFont":"index_bigFont_xEmFt","smallFont":"index_smallFont_3Pwv1","text":"index_text_TwFCV","shortText":"index_shortText_KJj8C"};